export const fast = '130ms';
export const smooth = '230ms';
export const slow = '350ms';
export const gradual = '530ms';